import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../../../../store/global-selectors';
import messages from '../../messages';
import style from './service-display.module.less';

const ServiceDisplay = ({ serviceId, sellerProviderId, className = '' }) => {
  const services = useSelector(Global.selectSellerServices);
  const service = services?.find((s) => s.serviceId === serviceId.toString());
  const intl = useIntl();

  const sellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  const selectedProvider = sellerLabelProviders.find((s) => parseInt(s.sellerLabelProviderId, 10) === sellerProviderId);
  const matchingSellerProviders = sellerLabelProviders.filter((s) => s.labelProviderId === service?.labelProviderId);
  const defaultSellerProvider = matchingSellerProviders.find((s) => s.isPrimaryAccount) ?? matchingSellerProviders[0];
  const hasMoreThanOneSellerProviderForThisService =
    sellerLabelProviders.filter((s) => s.labelProviderId === service?.labelProviderId).length > 1;
  const defaultProviderNameBackStop = defaultSellerProvider?.name ?? intl.formatMessage(messages.myPrimaryAccount);
  const sellerProviderIdName =
    service && sellerProviderId !== parseInt(defaultSellerProvider?.sellerLabelProviderId, 10)
      ? `(${selectedProvider?.name})`
      : `(${defaultProviderNameBackStop})`;
  return (
    <div className={classnames(style['service-display'], className)}>
      <div>{service?.name}</div>
      {hasMoreThanOneSellerProviderForThisService && (
        <div>
          <i>{sellerProviderIdName}</i>
        </div>
      )}
    </div>
  );
};

ServiceDisplay.propTypes = {
  serviceId: PropTypes.number.isRequired,
  sellerProviderId: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default ServiceDisplay;
